import { createContext } from 'react'

const FeaturesContext = createContext({ loading: true, features: [] })

const { Provider, Consumer } = FeaturesContext

export { Provider, Consumer }

export default FeaturesContext
